import { z } from 'zod';

import { careerTrackSchema, translatedContentSchema } from './career-track';
import { simplePaginationSchema } from './pagination';

export const levelingFrameworkSchema = z.object({
    id: z.uuid(),
    createdAt: z.iso.datetime(),
    currency: z.string(),
    description: z.string(),
    editable: z.boolean(),
    /** The job architectures that use this framework; absent until the backend reports it. */
    jobArchitectureIds: z.string().array().optional(),
    lastUpdate: z.iso.datetime(),
    name: z.string(),
    tracks: careerTrackSchema.array(),
    translations: translatedContentSchema.array().default([]),
    /** Whether translations into the tenant's languages are still running; absent when not tracked. */
    translationStatus: z.enum(['PENDING', 'COMPLETE', 'FAILED']).nullish(),
    type: z.enum(['MARKET', 'UNION', 'CUSTOM']),
});

export type LevelingFramework = z.infer<typeof levelingFrameworkSchema>;

export const paginatedLevelingFrameworkSchema = z.object({
    data: levelingFrameworkSchema.array(),
    pagination: simplePaginationSchema,
});

export type PaginatedLevelingFramework = z.infer<typeof paginatedLevelingFrameworkSchema>;
